import * as Yup from 'yup';
import { t } from 'i18next';
import { Dayjs } from 'dayjs';

export const validSchema = Yup.object().shape({
  from: Yup.mixed<Dayjs>()
    .nullable()
    .required(t('validation.valueIsRequired'))
    .default(null),
  to: Yup.mixed<Dayjs>()
    .nullable()
    .required(t('validation.valueIsRequired'))
    .default(null)
    .test(
      'dayjs-min',
      () =>
        t('dateRangeMismatch', {
          startDate: t('validFrom'),
          endDate: t('validTo')
        }),
      (to, ctx) => {
        const from = ctx.parent.from as Dayjs;
        return to && from ? to.isAfter(from) : true;
      }
    )
});

export const accountSchema = Yup.object().shape({
  accountName: Yup.string().required(t('validation.valueIsRequired')),
  comEmail: Yup.string()
    .email(t('invalidEmailAddress'))
    .required(t('validation.valueIsRequired')),
  nameFirst: Yup.string(),
  nameLast: Yup.string().required(t('validation.valueIsRequired')),
  valid: validSchema
});
export const groupsSchema = Yup.object().shape({
  groups: Yup.array().of(
    Yup.object().shape({
      groupId: Yup.string().required(t('validationEmptyUser')),
      valid: validSchema
    })
  )
});
